import { Helmet } from "react-helmet-async";

export default function SEO({
  title = "Indiana Accident Aid | Free 24/7 Help for Accident Victims",
  description = "Injured in Indiana? Get a free, no-obligation case review with experienced local attorneys. Available 24/7. No fees unless you win.",
  image,
  imageAlt,
  url,
  type = "website",
  schema,
  canonical,
  noindex = false,
}) {
  const fullTitle = title.includes("Indiana Accident Aid") ? title : `${title} | Indiana Accident Aid`;
  const canonicalHref = canonical
    || (typeof window !== "undefined" ? window.location.origin + window.location.pathname : undefined);
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex
        ? <meta name="robots" content="noindex, follow" />
        : <meta name="robots" content="index, follow" />}
      {/* Never emit a canonical on a not-found / noindex page (avoids a misleading self-canonical). */}
      {!noindex && canonicalHref && <link rel="canonical" href={canonicalHref} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Indiana Accident Aid" />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      {image && imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      {image && imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
